// Fetch live stock/ETF/mutual fund prices from Yahoo Finance via Vite dev proxy
const SKIP_TICKERS = new Set(['CASH', 'MARGIN']);

async function fetchSingleQuote(ticker) {
  try {
    const res = await fetch(
      `/api/yahoo/v8/finance/chart/${encodeURIComponent(ticker)}?range=1d&interval=1d`
    );
    if (!res.ok) return null;
    const json = await res.json();
    const meta = json.chart?.result?.[0]?.meta;
    if (!meta) return null;
    return {
      currentPrice: meta.regularMarketPrice ?? meta.previousClose ?? null,
    };
  } catch {
    return null;
  }
}

/**
 * Fetch current prices for a list of tickers.
 * Returns a map: { 'SCHD': { currentPrice: 31.05 }, ... }
 * Skips CASH / MARGIN pseudo-tickers.
 */
export async function fetchQuotes(tickers) {
  const unique = [...new Set(tickers.map((t) => t.toUpperCase()))].filter(
    (t) => !SKIP_TICKERS.has(t)
  );
  if (unique.length === 0) return {};

  const results = await Promise.allSettled(
    unique.map(async (ticker) => {
      const quote = await fetchSingleQuote(ticker);
      return { ticker, quote };
    })
  );

  const quotes = {};
  for (const result of results) {
    if (result.status === 'fulfilled' && result.value.quote?.currentPrice != null) {
      quotes[result.value.ticker] = result.value.quote;
    }
  }

  return quotes;
}
